import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

type ViewMode = 'grid' | 'list';

@Component({
  selector: 'app-view-mode-toggle',
  templateUrl: './view-mode-toggle.component.html',
  standalone: true,
  imports : [CommonModule],
  styleUrls: ['./view-mode-toggle.component.scss']
})
export class ViewModeToggleComponent {

  @Input() currentViewMode: ViewMode = 'grid'; // Default view mode
  @Output() viewModeChange = new EventEmitter<ViewMode>();

  toggleViewMode(): void {
    this.currentViewMode = this.currentViewMode === 'grid' ? 'list' : 'grid';
    this.viewModeChange.emit(this.currentViewMode);
  }

}